const countSelected = days => days.filter(d => d.selected).length;

export default countSelected;